import React from "react";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import {
  FilterChipGroup,
  SUBSCRIPTION_FILTER_OPTIONS,
} from "../UI/SubscriptionFilterChips";
import {
  DEFAULT_MY_COMPANIES_FILTERS,
  MY_COMPANIES_REGION_CODES,
} from "../../utils/myCompaniesFilterUtils";

const ENTITY_TYPE_OPTIONS = [
  { id: "company", label: "Компания" },
  { id: "partner", label: "Партнёр" },
  { id: "all", label: "Все" },
];

export function MyCompaniesFilters({
  filters,
  onChange,
  canViewEventTotals = false,
}) {
  const f = filters ?? DEFAULT_MY_COMPANIES_FILTERS;

  const setField = (patch) => {
    onChange?.({ ...f, ...patch });
  };

  const toggleRegion = (code) => {
    setField({
      regions: { ...f.regions, [code]: !f.regions[code] },
    });
  };

  return (
    <section
      className="card dash-card my-companies-filters"
      aria-label="Фильтры дашборда"
    >
      <div className="my-companies-filters-layout">
        <div className="my-companies-filters-row">
          <FilterChipGroup
            label="Подписка"
            groupName="my-companies-subscription"
            options={SUBSCRIPTION_FILTER_OPTIONS}
            value={f.subscription}
            onChange={(id) => setField({ subscription: id })}
          />
          <FilterChipGroup
            label="Тип"
            groupName="my-companies-entity-type"
            options={ENTITY_TYPE_OPTIONS}
            value={f.entityType}
            onChange={(id) => setField({ entityType: id })}
          />
          <div className="my-companies-filter-group">
            <span className="my-companies-filter-label">Регион</span>
            <div className="subscription-period-chips my-companies-filter-chips">
              {MY_COMPANIES_REGION_CODES.map((code) => (
                <button
                  key={code}
                  type="button"
                  className={
                    f.regions[code]
                      ? "subscription-period-chip subscription-period-chip--active"
                      : "subscription-period-chip"
                  }
                  aria-pressed={!!f.regions[code]}
                  onClick={() => toggleRegion(code)}
                >
                  {code}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="my-companies-filters-row">
          <div className="my-companies-filter-group my-companies-filter-group--toggles">
            <span
              className="my-companies-filter-label my-companies-filter-label--spacer"
              aria-hidden="true"
            />
            <div className="my-companies-filter-toggles">
              <CcV4Toggle
                active={f.errorsOnly}
                label="Только с ошибками"
                onClick={() => setField({ errorsOnly: !f.errorsOnly })}
              />
              {canViewEventTotals ? (
                <CcV4Toggle
                  active={f.defectMin3}
                  label="Брак ≥3%"
                  onClick={() => setField({ defectMin3: !f.defectMin3 })}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
